function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import axios from 'axios';
import { useQuery } from 'react-query';
import useApplicationState from './useApplicationState';

var useGetResolutions = () => {
  var {
    apiUrl,
    apiKey
  } = useApplicationState();
  var queryResult = useQuery(['getResolutions', {
    apiUrl,
    apiKey
  }], /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (_ref) {
      var _yield$axios$get;

      var {
        queryKey
      } = _ref;
      return (_yield$axios$get = yield axios.get("".concat(apiUrl, "/olpixelsize"), {
        headers: {
          'X-API-Key': queryKey[1].apiKey || ''
        }
      })) === null || _yield$axios$get === void 0 ? void 0 : _yield$axios$get.data;
    });

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), {
    enabled: !!(apiUrl && apiKey)
  });
  return queryResult.data;
};

export default useGetResolutions;